import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SalesProductionChartComponent } from '../sales-production-chart/sales-production-chart.component';
import { TopSellingProductsChartComponent } from '../top-selling-products-chart/top-selling-products-chart.component';
import { TopCancelledProductsChartComponent } from '../top-cancelled-products-chart/top-cancelled-products-chart.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, SalesProductionChartComponent, TopSellingProductsChartComponent, TopCancelledProductsChartComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  // O loading do dashboard é por card de gráfico (cada componente controla o
  // próprio estado). Não há mais spinner full-screen bloqueando a aplicação.
  constructor(private router: Router) { }

  navigateTo(route: string) {
    this.router.navigate(['/' + route]);
  }
}
